import { cn } from "@/lib/utils";
import type { CSSProperties } from "react";

type Sparkle = {
  x: number;
  y: number;
  size: number;
  delay: number;
  shape: "diamond" | "dot";
  color?: string;
};

const SPARKLES: ReadonlyArray<Sparkle> = [
  { x: -40, y: -20, size: 8, delay: 0.05, shape: "diamond" },
  { x: -20, y: -40, size: 6, delay: 0.1, shape: "dot" },
  { x: 10, y: -45, size: 7, delay: 0.12, color: "#B8FFB0", shape: "dot" },
  { x: 30, y: -30, size: 6, delay: 0.08, shape: "diamond" },
  { x: 40, y: -5, size: 6, delay: 0.14, shape: "dot" },
  { x: 30, y: 20, size: 8, delay: 0.18, shape: "diamond" },
  { x: 0, y: 35, size: 7, delay: 0.16, shape: "dot" },
  { x: -30, y: 25, size: 6, delay: 0.2, shape: "dot" },
  { x: -45, y: 0, size: 5, delay: 0.06, shape: "diamond" },
  { x: 15, y: 30, size: 5, delay: 0.17, shape: "dot" },
];

export function PrizeSparkles({ className }: { className?: string }) {
  return (
    <div
      className={cn("pointer-events-none absolute inset-0 -z-10", className)}
    >
      <style>{`
        @keyframes prize-sparkle {
          0% {
            transform: translate(-50%, -50%) scale(0.2) rotate(0deg);
            opacity: 0;
          }
          35% {
            opacity: 1;
          }
          100% {
            transform: translate(
                calc(-50% + var(--x)),
                calc(-50% + var(--y))
              )
              scale(1.2)
              rotate(30deg);
            opacity: 0;
          }
        }
      `}</style>
      {SPARKLES.map((sparkle, index) => (
        <div
          key={index}
          className={cn(
            "absolute left-1/2 top-1/2 opacity-0",
            sparkle.shape === "diamond" ? "rotate-45" : "",
          )}
          style={
            {
              animation: `prize-sparkle 1550ms ease-out ${0.2 + sparkle.delay}s infinite`,
              animationDelay: `${sparkle.delay}s`,
              "--x": `${sparkle.x}px`,
              "--y": `${sparkle.y}px`,
            } as CSSProperties
          }
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 480 480"
            style={{
              width: `${sparkle.size}px`,
              height: `${sparkle.size}px`,
              color: sparkle.color ?? "var(--color-yellow-200)",
              filter: "drop-shadow(0 0 4px currentColor)",
            }}
          >
            <path
              d="M480 240A240 240 0 0 1 240 0 240 240 0 0 1 0 240a240 240 0 0 1 240 240 240 240 0 0 1 240-240Z"
              fill="currentColor"
            />
          </svg>
        </div>
      ))}
    </div>
  );
}
